// extracted by mini-css-extract-plugin
module.exports = {"page":"ProptradingLayout_page__h3f6N","main":"ProptradingLayout_main__5pVQZ"};